export interface ISpcMethodAnalyte {
 
  methodRefTxt: string;
  methodRefTxt2: string;
  methodRefTxt3: string;
  methodRefTxt4: string;
  analyte: string;
  analyteStatus: string;
  matrix: string;
  siteState: string;
  fileType: string;

}

export interface IPastLogins {
  ipAddress: string;
  loginName: string;
  dateLogin: Date;
  dateLogout: Date;
  id: number;
  expr1: string;
  firstName: string;
  lastName: string;
  companyName: string;
}

export interface IBillableReportParameters {
  dbFundCode: string;
  dbPHL: string;
  dbDEQ: string;
}

